<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">
          {{
            $t(
              'school.academic.operation.profile_mgt.studentProfile.studentInquiry'
            )
          }}
        </h4>
        <ts-modal-close-button />
      </div>
      <ts-card-wrapper>
        <ts-input
          class="form-control d-block mb-2"
          v-model="searchText"
          :placeholder="$t('Search')"
        />
      </ts-card-wrapper>
      <div class="overflow-auto" style="max-height: 1vh; min-height: 300px">
        <ts-table
          :loading="loading"
          :columns="columns"
          :records="studentInquiries"
        >
          <template v-slot="{ record }">
            <td class="text-center ts-whitespace-no-wrap">
              <a
                href="#"
                title="Add To Profile"
                class="text-primary"
                @click.prevent="select(record)"
              >
                <i class="fas fa-plus"></i>
              </a>
            </td>
            <td>{{ record.full_name_en }}</td>
            <td>{{ record.full_name_kh }}</td>
            <td class="text-center">{{ record.gender }}</td>
            <td class="text-center">{{ record.date_of_birth }}</td>
            <td>{{ record.contact_name }}</td>
            <td class="text-center">{{ record.contact_number }}</td>
            <td>{{ record.email }}</td>
          </template>
        </ts-table>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions } from 'vuex'

export default {
  name: 'StudentInquiry',
  props: ['value'],
  data () {
    return {
      model: {},
      searchText: '',
      studentInquiries: [],
      loading: false
    }
  },
  computed: {
    columns () {
      return [
        {
          name: this.$t('')
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.nameEn'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.nameKh'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.gender'
          ),
          style: 'text-align:center;'
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.dateOfBirth'
          ),
          style: 'text-align:center;'
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.contactName'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.contactNumber'
          ),
          style: 'text-align:center;'
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.studentProfile.email'
          )
        }
      ]
    }
  },
  created () {
    this.fetchStudentInquiry()
    this.model = this.value
  },
  methods: {
    ...mapActions('studentProfile', [
      'getDistrict',
      'getCommune',
      'getVillage'
    ]),
    fetchStudentInquiry (attributes) {
      this.loading = true
      this.$store
        .dispatch('studentProfile/fetchInfoInquiries', Object.assign(
          { branch_id: this.$store.state.authUser.default_branch_id },
          { ...attributes }
        ))
        .then(response => {
          this.studentInquiries = response
          this.model = this.value
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    select (inquiry) {
      this.getDistrict(inquiry.province_code)
      this.getCommune(inquiry.district_code)
      this.getVillage(inquiry.commune_code)
      this.model.first_name_kh = inquiry.first_name_kh
      this.model.last_name_kh = inquiry.last_name_kh
      this.model.first_name_en = inquiry.first_name_en
      this.model.last_name_en = inquiry.last_name_en
      this.model.date_of_birth = inquiry.date_of_birth
      this.model.place_of_birth = inquiry.place_of_birth
      this.model.province_code = inquiry.province_code
      this.model.district_code = inquiry.district_code
      this.model.commune_code = inquiry.commune_code
      this.model.village_code = inquiry.village_code
      this.model.street_no = inquiry.street
      this.model.house_no = inquiry.house
      this.model.ac_st_id = inquiry.ac_st_id
      this.model.nationality = inquiry.na_id
      this.model.facebook_account = inquiry.facebook
      this.model.linked_in = inquiry.linkin
      this.model.telegram = inquiry.telegram
      this.model.line = inquiry.line
      this.model.we_chart = inquiry.we_chat
      this.model.emergency_contact_person = inquiry.contact_name
      this.model.emergency_contact_relation = inquiry.relationship
      this.model.emergency_contact_phone = inquiry.contact_number
      this.model.phone = inquiry.contact_number
      this.model.inquiry_id = inquiry.inquiry_id
      this.model.changed_in_from_school = inquiry.from_school
      this.model.email = inquiry.email
      this.$emit('close')
      this.model.gender =
        inquiry.gender !== null
          ? inquiry.gender.trim() == 'F'
            ? 'Female'
            : 'Male'
          : ''
    }
  },
  watch: {
    searchText: debounce(function () {
      this.fetchStudentInquiry({search:this.searchText})
    }, 500)
  }
}
</script>
<style lang="scss" scoped>
table td {
  vertical-align: middle;
}
::-webkit-scrollbar {
  height: 8px;
  width: 3px; /* Remove scrollbar space */
  background: #ffff; /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
  border-radius: 4px;
  background: #e5e7e7;
}
div::-webkit-scrollbar-thumb:hover {
  background: #b7b7b8;
}
</style>
